import common from './common'
import dark from './dark'
import light from './light'

const themes = { common, dark, light }

export default themes
